<div *ngFor="let alert of alerts" class="{{ cssClass(alert) }}">
  <div [innerHTML]="alert.message"></div>
  <!-- <button type="button" class="btn-close" (click)="removeAlert(alert)"></button> -->
</div>
